import React from 'react';
import Fade from '@material-ui/core/Fade';
import SnackbarContent from '@app/components/Snackbar/SnackbarContent';
import withStyles from "@material-ui/core/styles/withStyles";
import messageStyle from "@app/assets/jss/material-kit-pro-react/components/messageStyle";

function Message({ ...props }) {
    const {
      classes
    } = props;
    let color = 'info';
    if (props.type) {
        if (props.type === 'error') {
            color = 'danger';
        } 
        else if (props.type === 'success') {
            color = 'success';
        }
        else if (props.type === 'warning') {
            color = 'warning';
        }
    }
    return (
        <Fade  in={true} mountOnEnter unmountOnExit>
            <SnackbarContent color={color} message={
                <span className={classes.messageText}>{props.message}</span>
            }/>
        </Fade>
    );
}

export default withStyles(messageStyle)(Message)
